import { createFileRoute, redirect } from "@tanstack/react-router"

import PermissionDeniedAlert from "@/components/common/Alerts/PermissionDeniedAlert"
import { FINANCIAL_REPORTING_PERMISSIONS } from "@/constants/permissions"
import { useCurrentUserStore } from "@/stores/currentUserStore"

export const Route = createFileRoute("/app/financial-reporting/")({
  beforeLoad: () => {
    const { currentUser } = useCurrentUserStore.getState()
    const hasAccess = FINANCIAL_REPORTING_PERMISSIONS.some((permission) =>
      currentUser?.permissions?.includes(permission)
    )

    if (hasAccess) {
      throw redirect({ to: "/app/financial-reporting/ap-aging-report" })
    }
  },
  component: () => <PermissionDeniedAlert />,
})
